export default __webpack_public_path__ + "64312d2652fe4b7751de1b598e82d284.svg";